import * as yup from 'yup';

export const cancellationValidationSchema = yup.object().shape({
  underageForm: yup.object().shape({
    date: yup.date().nullable().typeError('Data non valida').required('Campo obbligatorio'),
    reason: yup.string().required('Campo obbligatorio'),
  }),
});
